import "@/styles/SimpleDialog.scss";

interface SimpleDialogProps {
    children?: React.ReactNode;
    message1?: React.ReactNode;
    message2?: React.ReactNode;
    message3?: string | React.ReactNode;
}

const SimpleDialog = ({ children, message1, message2, message3 }: SimpleDialogProps): React.JSX.Element => {
    return (
        <div className="dialogue-container">
            <div className="dialogue-message-container">
                <div className="dialogue-message1">{message1}</div>
                {children}
                <div className="dialogue-message2">{message2}</div>
                <div className="dialogue-message3">{message3}</div>
            </div>
        </div>
    );
};

export default SimpleDialog;
